import { useAuth } from "@/features/auth/index.js";
import { manualParaRol } from "../manual-content.js";

const labelClass =
  "font-mono text-[0.625rem] font-medium uppercase tracking-[0.18em] text-muted-foreground";

/**
 * Contenido del manual (segmentado por rol), SIN marco. Lo usa la ruta /manual
 * (envuelto en AccountShell) y el AdminPanel como vista interna.
 */
export function ManualContent() {
  const { user } = useAuth();
  const rol = user?.rol ?? "technician";
  const secciones = manualParaRol(rol);
  const titulo = rol === "admin" ? "Manual del administrador" : "Manual del técnico";

  return (
    <div className="forja-rise space-y-10">
      <header className="space-y-2">
        <p className={labelClass}>Guía de uso</p>
        <h1 className="text-2xl font-semibold text-foreground">{titulo}</h1>
        <p className="text-sm text-muted-foreground">
          Todo lo que necesitas para sacarle provecho a Marco Reportes, paso a paso.
        </p>
      </header>

      {secciones.map((seccion, i) => (
        <section key={seccion.title} className="space-y-4">
          <div className="flex items-baseline gap-3">
            <span className="font-mono text-sm font-semibold text-brand-accent">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div>
              <h2 className="text-lg font-semibold text-foreground">{seccion.title}</h2>
              <p className="text-sm text-muted-foreground">{seccion.intro}</p>
            </div>
          </div>

          <ol className="space-y-3 border-l border-border pl-4 sm:pl-6">
            {seccion.steps.map(({ icon: Icon, title, body }) => (
              <li key={title} className="relative">
                <span className="absolute -left-[1.65rem] flex size-8 items-center justify-center rounded-lg border border-border bg-card sm:-left-[2.4rem]">
                  <Icon className="size-4 text-foreground" aria-hidden />
                </span>
                <div className="rounded-2xl border border-border bg-card p-4">
                  <p className="font-medium text-foreground">{title}</p>
                  <p className="mt-1 text-sm text-muted-foreground">{body}</p>
                </div>
              </li>
            ))}
          </ol>
        </section>
      ))}
    </div>
  );
}
